// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogCategoryNav_container__9urQL","category-list":"BlogCategoryNav_category-list__2Vxyp","toggle":"BlogCategoryNav_toggle__2BTo4"};